import React, { useContext, useEffect, useState } from "react";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { Select } from "../../../../assets/css/components/admin/products/ShowProductInfo/ShowProductInfo.css";
import handleAxiosError from "../../update-and-publish/functions/handleAxiosError";
import axios from "axios";
import {
  keyAccessToken,
  keyUserId,
} from "../../../../assets/js/SessionStorageNames";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import HomeCenterCredentials from "./homeCenterCredentials";
import { syncProductsHomeCenter, updateProductsHomeCenter } from "../../../../hooks/api/homeCenter";

export default function View({ username, step = 2, listUsers }) {
  const [loading, setLoading] = useState(false);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [tarifas, setTarifas] = useState([]);
  const [tarifaSelected, setTarifaSelected] = useState(null);
  const globalContext = useContext(GlobalContext);
  const [skuId, setSkuId] = useState(null);

  const changeTarifa = (t) => {
    setTarifaSelected(t);
    console.log(t);
  };

  const syncProducts = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      const resp = await syncProductsHomeCenter(entId, username)
      if (resp?.message) await globalContext.showModalWithMsg('Se ha iniciado el proceso de sincronización de productos en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al sincronizar los productos.');
    }
  }

  const updateProducts = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      console.log(skuId, 'sku')
      const resp = await updateProductsHomeCenter(entId, username, skuId)
      if (resp?.message) await globalContext.showModalWithMsg('Se ha iniciado el proceso de actualización de productos en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al actualizar los productos.');
    }
  }

  /**
   * Function to consult the lists of available rates
   */
  async function getPriceList() {
    const entId = await globalContext.currentEnterpriseId;
    const url = `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`;
    if (entId)
      await axios
        .get(url, {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        })
        .then((resp) => {
          const data = resp.data.data;
          setTarifas(data.priceLists);
          console.log(data.priceLists);
        })
        .catch((err) => {
          console.log(err);
          handleAxiosError(
            err,
            "Disculpe, no se pudo cargar la lista de tarifas."
          );
        });
  }

  useEffect(() => {
    getPriceList();
  }, [globalContext.currentEnterpriseId]);

  return (
    <>
      {step === 2 ? (
        <>
          <PedidosYaStyle.ContForm style={{ marginTop: 55 }}>
            <PedidosYaStyle.HeaderForm>
              <PedidosYaStyle.Text size="14pt" fw="500" cl="#4a5568">
                Operaciones de {username}
              </PedidosYaStyle.Text>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm>
              {/* Grid de Operaciones */}
              <div style={{ padding: "30px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
                
                {/* Card: Sincronizar Productos */}
                <div style={{ 
                  backgroundColor: "white", 
                  borderRadius: "12px", 
                  padding: "24px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.1)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.05)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
                >
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                    <div style={{ 
                      width: "48px", 
                      height: "48px", 
                      borderRadius: "10px", 
                      backgroundColor: "#edf2f7",
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      fontSize: "24px",
                      marginRight: "12px"
                    }}>
                      🔄
                    </div>
                    <div>
                      <PedidosYaStyle.Text size="14pt" fw="600" cl="#2d3748">
                        Sincronizar Productos
                      </PedidosYaStyle.Text>
                    </div>
                  </div>
                  
                  <PedidosYaStyle.Text size="11pt" cl="#718096" style={{ display: "block", marginBottom: "16px", lineHeight: "1.5" }}>
                    Sincroniza todos los productos de Home Center con tu inventario local.
                  </PedidosYaStyle.Text>
                  
                  <PedidosYaStyle.BtnSend
                    onClick={syncProducts}
                    disabled={loading}
                    style={{ 
                      width: "100%", 
                      textAlign: "center",
                      padding: "12px 20px",
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: "600",
                      backgroundColor: loading ? "#cbd5e0" : "#4299e1",
                      border: "none",
                      cursor: loading ? "not-allowed" : "pointer",
                      transition: "all 0.2s ease",
                      boxShadow: loading ? "none" : "0 2px 4px rgba(66, 153, 225, 0.3)"
                    }}
                    onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = "#3182ce")}
                    onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = "#4299e1")}
                  >
                    {loading ? "⏳ Sincronizando..." : "Sincronizar Ahora"}
                  </PedidosYaStyle.BtnSend>
                </div>

                {/* Card: Descargar Categorías */}
                <div style={{ 
                  backgroundColor: "white", 
                  borderRadius: "12px", 
                  padding: "24px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.1)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.05)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
                >
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                    <div style={{ 
                      width: "48px", 
                      height: "48px", 
                      borderRadius: "10px", 
                      backgroundColor: "#f0fdf4",
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      fontSize: "24px",
                      marginRight: "12px"
                    }}>
                      📥
                    </div>
                    <div>
                      <PedidosYaStyle.Text size="14pt" fw="600" cl="#2d3748">
                        Actualizar Stock de Productos
                      </PedidosYaStyle.Text>
                    </div>
                  </div>
                  
                  <PedidosYaStyle.Text size="11pt" cl="#718096" style={{ display: "block", marginBottom: "16px", lineHeight: "1.5" }}>
                    Actualiza el stock de todos los productos de Home Center.
                  </PedidosYaStyle.Text>
                  
                  <PedidosYaStyle.BtnSend
                    onClick={updateProducts}
                    disabled={loading}
                    style={{ 
                      width: "100%", 
                      textAlign: "center",
                      padding: "12px 20px",
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: "600",
                      backgroundColor: loading ? "#cbd5e0" : "#48bb78",
                      border: "none",
                      cursor: loading ? "not-allowed" : "pointer",
                      transition: "all 0.2s ease",
                      boxShadow: loading ? "none" : "0 2px 4px rgba(72, 187, 120, 0.3)"
                    }}
                    onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = "#38a169")}
                    onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = "#48bb78")}
                  >
                    {loading ? "⏳ Actualizando..." : "Actualizar Ahora"}
                  </PedidosYaStyle.BtnSend>
                </div>

              </div>

              {/* Información adicional */}
              <div style={{ 
                padding: "20px 30px", 
                backgroundColor: "#f7fafc", 
                borderTop: "1px solid #e2e8f0"
              }}>
                <PedidosYaStyle.Text size="11pt" cl="#718096" style={{ display: "block", lineHeight: "1.6" }}>
                  ℹ️ <strong>Nota:</strong> Las operaciones se ejecutan en segundo plano. Puedes revisar en la nube en la esquina superior derecha.
                </PedidosYaStyle.Text>
              </div>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </>
      ) : (
        <>
          <HomeCenterCredentials username={username} loading={loading} setLoading={setLoading} listUsers={listUsers} />
        </>
      )}
    </>
  );
}


